import { useLayoutEffect } from 'react';

const useLockBodyScroll = (isOpen: boolean): void => {
  useLayoutEffect(() => {
    if (document) {
      if (isOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'visible';
      }
    }
  }, [isOpen]);
};

export default useLockBodyScroll;
